import { apiGet } from "./helpers/api";
import { normalize, schema } from "normalizr";
import toQueryString from "../utils/toQueryString";

const questionStem = new schema.Entity("questionStems");

const question = new schema.Entity("questions", {
  meta: {
    questionStems: [questionStem],
  },
});

export const fetchQuestions = (dispatch, mockId) => {
  apiGet(`/api/v1/mocks/${mockId}/questions`).then((response) => {
    dispatch({
      type: "QUESTIONS_FETCHED",
      ...normalize(response.body.data, new schema.Array(question)),
    });
  });
};

export const goToIndex = (dispatch, index) =>
  dispatch({ type: "CURRENT_INDEX_CHANGED", index });

export const QUESTION_SEARCH_PER_PAGE = 10;

// `textContains` procura no título (V1), no context e nos enunciados (V2) —
// filtrar só pelo título deixaria a busca de um curso migrado sem resultado.
const buildSearchFilters = (search) =>
  Number.isNaN(+search) ? { textContains: search } : { idEq: search };

export const fetchQuestionSearch = (dispatch, search, page = 1) => {
  if (!search) {
    return;
  }

  const searchParams = toQueryString(buildSearchFilters(search));

  dispatch({ type: "QUESTIONS_SEARCH_FETCH_REQUESTED" });

  return apiGet(
    `/api/v1/questions?${searchParams}page=${page}&per_page=${QUESTION_SEARCH_PER_PAGE}`
  ).then((response) => {
    const { data, totalPages, totalCount, currentPage } = response.body;

    dispatch({
      type: "QUESTIONS_SEARCH_FETCHED",
      totalPages,
      totalCount,
      currentPage,
      ...normalize(data, new schema.Array(question)),
    });
  });
};

// Digitar sempre volta para a primeira página.
export const submitSearch = (values, dispatch) =>
  fetchQuestionSearch(dispatch, values.search, 1);
